<div class="flex flex-col gap-2">
  <label class="text-xs sm:text-sm font-medium text-gray-700">Número de WhatsApp</label>
  <div class="flex gap-2">
    <select
      class="w-28 rounded-md border border-gray-300 px-2 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
      [ngModel]="selectedCountryCode()"
      (ngModelChange)="selectedCountryCode.set($event)"
      [disabled]="disabled()"
    >
      @for (country of countryCodes; track country.code) {
        <option [value]="country.code">{{ country.flag }} {{ country.code }}</option>
      }
    </select>
    <input
      type="tel"
      class="flex-1 rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
      placeholder="999999999"
      [value]="numeroCelular()"
      (input)="onPhoneNumberChange($any($event.target).value)"
      [disabled]="disabled()"
      maxlength="15"
      minlength="6"
    />
  </div>
  @if (numeroCelular() && numeroCelular().length < 6) {
    <span class="text-xs text-red-500">El número debe tener al menos 6 dígitos</span>
  }
</div>
